import IO from './IO';
import Localization from '../utils/Localization';

let path;
let samples;
let backgrounds;
let sprites;
let sounds;
let keys = {};

export default class MediaLib {
    static get path () {
        return path;
    }

    static get samples () {
        return samples;
    }

    static get sprites () {
        return sprites;
    }

    static get backgrounds () {
        return backgrounds;
    }

    static get sounds () {
        return sounds;
    }

    static get keys () {
        return keys;
    }

    static loadMediaLib (root, whenDone) {
        console.log('📚 [MEDIALIB] loadMediaLib called with root:', root);
        IO.requestFromServer(root + 'media.json', (result) => {
            console.log('📚 [MEDIALIB] media.json received, length:', result.length);
            let parsedResult = JSON.parse(result);
            console.log('📚 [MEDIALIB] Parsed media.json:', {
                samplesCount: parsedResult.samples && parsedResult.samples.length,
                spritesCount: parsedResult.sprites && parsedResult.sprites.length,
                backgroundsCount: parsedResult.backgrounds && parsedResult.backgrounds.length,
                soundsCount: parsedResult.sounds && parsedResult.sounds.length
            });
            path = parsedResult.path;
            samples = parsedResult.samples;
            sprites = parsedResult.sprites;
            backgrounds = parsedResult.backgrounds;
            sounds = parsedResult.sounds;

            console.log('📚 [MEDIALIB] Module variables set - samples:', samples && samples.length, 'sprites:', sprites && sprites.length);

            MediaLib.localizeMediaNames();
            console.log('📚 [MEDIALIB] Media names localized');

            MediaLib.generateKeys();
            console.log('📚 [MEDIALIB] Keys generated - calling whenDone callback');

            whenDone();
        });
    }

    static localizeMediaNames () {
        // Localize names of sprites
        for (let i = 0; i < sprites.length; i++) {
            sprites[i].name = Localization.localize('CHARACTER_' + sprites[i].md5);
        }

        // Localize names of backgrounds
        for (let i = 0; i < backgrounds.length; i++) {
            backgrounds[i].name = Localization.localize('BACKGROUND_' + backgrounds[i].md5);
        }
    }

    static generateKeys () {
        for (let i = 0; i < backgrounds.length; i++) {
            var bg = backgrounds[i];
            keys[bg.md5] = {width: bg.width, height: bg.height, name: bg.name};
        }

        for (let i = 0; i < sprites.length; i++) {
            var spr = sprites[i];
            keys[spr.md5] = {width: spr.width, height: spr.height, name: spr.name};
        }
    }
}
